import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Responsive Typography Utility
 * Provides consistent typography classes based on the design system mapping
 */
export const responsiveTypography = {
  // Direct font size classes (following Tailwind conventions)
  "3xl": "text-3xl",
  "2xl": "text-2xl",
  xl: "text-xl",
  lg: "text-lg",
  base: "text-base",
  sm: "text-sm",
  xs: "text-xs",
  "2xs": "text-2xs",

  // Common typography combinations
  hero: "text-3xl font-bold font-space-grotesk",
  heading: "text-2xl font-semibold font-space-grotesk",
  title: "text-xl font-semibold font-dm-sans",
  body: "text-base font-normal font-dm-sans",
  caption: "text-sm font-normal font-dm-sans",
  label: "text-xs font-medium font-dm-sans",
  button: "text-xs font-semibold font-dm-sans",
} as const;

/**
 * Get responsive font size class based on design system mapping
 * @param size - The font size from the design system (3xl, 2xl, xl, lg, base, sm, xs, 2xs)
 * @returns The corresponding Tailwind class (following Tailwind CSS conventions)
 */
export function getResponsiveFontSize(size: keyof typeof responsiveTypography): string {
  return responsiveTypography[size];
}
